import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { SerasaCadastroResponse } from '../../../services/serasaService';

interface Props {
  data: SerasaCadastroResponse;
}

const CadastroSerasaResultDisplay: React.FC<Props> = ({ data }) => {
  return (
    <div className="mt-4">
      <h5 className="mb-3">Resultado da Análise</h5>
      <table className="table table-bordered">
        <tbody>
          <tr>
            <td className="table-light" style={{ width: '25%' }}><strong>Resultado</strong></td>
            <td className={data.result === 'SEM RISCO APARENTE' ? 'text-success fw-bold' : ''}>
              {data.result}
            </td>
          </tr>
          <tr>
            <td className="table-light"><strong>Score / Rank</strong></td>
            <td>{data.rank !== null ? data.rank : '-'}</td>
          </tr>
          <tr>
            <td className="table-light"><strong>ID / Protocolo</strong></td>
            <td>{data.id}</td>
          </tr>
          <tr>
            <td className="table-light"><strong>CPF Analisado</strong></td>
            <td>{data.cpf}</td>
          </tr>
          {data.additionalInformation && data.additionalInformation.length > 0 && (
            <tr>
              <td className="table-light"><strong>Informações Adicionais</strong></td>
              <td>
                <ul className="mb-0 ps-3">
                  {data.additionalInformation.map((info, idx) => (
                    <li key={idx}>{info}</li>
                  ))}
                </ul>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CadastroSerasaResultDisplay;